import React, { useEffect, useState } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
import { Button } from "primereact/button";

const useAccumulatorOverrideStateSchedule = () => {
  const [data, setData] = useState([]); /* Price Schedule Data */
  const { axios_helper_no_header } = useAxios();
  const {
    ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
    ADD_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE,
    EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE,
    DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE,
  } = ROUTE_PATHS;
  const location = useLocation();
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  let {
    selectedCriterias = [],
    previousScreen = ACCUMULATOR_OVERRIDE_SCHEDULE_CRITERIA,
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData,
  } = currentState;
  const [paramsData, setParamsData] = useState({
    ...initialParamsData,
    conditionDescription1: "",
    aocSeqNbr: selectedCriterias[initialIndex]?.aocSeqNbr,
    hiddenRecordIndicator: "A",
  }); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [isInactiveConfirmationModalOpen, setIsInactiveConfirmationModalOpen] =
    useState(false);
  const [inactiveSelectedOption, setInactiveSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const toast = useToast();

  const screen_title = "State CSR Criteria in Accum O/R Sched";
  const screenNumber = "RCAOT001";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "AOS Accum Ovrd Schedule",
      name: "aosAccumOvrdSchedule",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 15,
    },
    {
      fieldLabel: "DescriptAOS Accum Ovrd Scde Descion",
      name: "aosAccumOvrdScdeDesc",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "AOS Accum Ovrd Scde Type*ALL values",
      name: "aosAccumOvrdScdeType",
      label: "Type",
      type: "dropdown",
      fieldNature: "readOnly",
      value: "",
      maxLength: 50,
    },
    {
      fieldLabel: "AOC Seq Nbr",
      name: "aocSeqNbr",
      label: "Sequence",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 3,
    },
    {
      fieldLabel: "Hidden Records Indicator*Inactive",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      value: "",
      maxLength: 3,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Hidden Records Indicator", condition: "*Inactive" },
    { field_label: "AOS Accum Ovrd Scde Type", condition: "*ALL values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };
  const handleBack = () => {
    if (currentIndex < selectedCriterias.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Add State CSR Criteria in Accum O/R Sched",
      button_handeler: () => {
        navigateToPage(ADD_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            previousScreen: location.pathname,
            paramsData,
          },
        ]);
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        editValidation();
      },
    },
    {
      label: "Inactivate",
      icon: <span className="material-icons">block</span>,
      command: () => {
        openInactiveConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        {
          navigateToPage(DISPLAY_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE, [
            ...previousState,
            { ...currentState, currentIndex },
            {
              selectedCSRStates: selectedRows.length ? selectedRows : [rowData],
              previousScreen: location.pathname,
              paramsData,
            },
          ]);
        }
      },
    },
  ];

  const openInactiveConfirmationModal = () => {
    setIsInactiveConfirmationModalOpen(true);
  };

  const closeInactiveConfirmationModal = () => {
    console.log(inactiveSelectedOption);
    setIsInactiveConfirmationModalOpen(false);
    setInactiveSelectedOption("no");
  };

  const inActivateSchedule = () => {
    if (inactiveSelectedOption === "yes") {
      const params = {
        aosAccumOvrdSchedule: paramsData.aosAccumOvrdSchedule,
        screenNumber: screenNumber,
        aocSeqNbr: paramsData.aocSeqNbr,
        aotStateCsrLevel: rowData.aotStateCsrLevel,
        aotSeqNbr: rowData.aotSeqNbr,
      };
      axios_helper_no_header(
        "PUT",
        "api/aotstatescheduleovrd/inActivate",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeInactiveConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error inactivating the data!", error);
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeInactiveConfirmationModal();
        });
    } else {
      closeInactiveConfirmationModal();
    }
  };

  const viewScheduleOverride = (schedule) => {
    const fieldMapping = {
      B: {
        target: "bscScheduleName",
        targetPath: ROUTE_PATHS.BENEFIT_MAX_SCHEDULE_DISPLAY,
      },

      O: {
        target: "opcScheduleName",
        targetPath: ROUTE_PATHS.DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE,
      },

      T: {
        target: "tscScheduleName",
        targetPath: ROUTE_PATHS.TROOP_SCHEDULE_DISPLAY,
      },

      E: {
        target: "tscScheduleName",
        targetPath: ROUTE_PATHS.TROOP_SCHEDULE_DISPLAY,
      },

      D: {
        target: "dscScheduleName",
        targetPath: ROUTE_PATHS.DISPLAY_DEDUCTIBLE_SCHEDULE,
      },

      L: {
        target: "dscScheduleName",
        targetPath: ROUTE_PATHS.DISPLAY_DEDUCTIBLE_SCHEDULE,
      },
    };
    const { target, targetPath } =
      fieldMapping[paramsData.aosAccumOvrdScdeType] ?? {};
    navigateToPage(targetPath, [
      ...previousState,
      { ...currentState, currentIndex, paramsData },
      {
        selectedSchedules: [{ [target]: schedule }],
        previousScreen: location.pathname,
        currentIndex: 0,
      },
    ]);
  };

  const editValidation = () => {
    const params = {
      aosAccumOvrdSchedule: paramsData.aosAccumOvrdSchedule,
      aocSeqNbr: paramsData.aocSeqNbr,
      aotStateCsrLevel: rowData.aotStateCsrLevel,
      aotSeqNbr: rowData.aotSeqNbr,
    };
    axios_helper_no_header(
      "GET",
      "api/aotstatescheduleovrd/validateBeforeEdit",
      null,
      params
    )
      .then((response) => {
        {
          navigateToPage(EDIT_ACCUMULATOR_OVERRIDE_SCHEDULE_STATE, [
            ...previousState,
            { ...currentState, currentIndex },
            {
              selectedCSRStates: selectedRows.length ? selectedRows : [rowData],
              previousScreen: location.pathname,
              paramsData,
            },
          ]);
        }
      })
      .catch((error) => {
        console.error("There was an error editing the data!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  /* Data table column info. */
  const columnDef = [
    {
      header: "State CSR Level",
      field: "aotStateCsrLevel",
    },
    {
      header: "Schedule Override",
      field: "aotScheduleOvrd",
      body: (rowData) => {
        // viewPatientPayScheduleDetails(rowData);
        return (
          <Button
            label={rowData["aotScheduleOvrd"]}
            link
            onClick={(e) => {
              viewScheduleOverride(rowData["aotScheduleOvrd"]);
              // navigateToAccumsListDetails(rowData);
            }}
          />
        );
      },
    },
    {
      header: "Status",
      field: "aotStatus",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "aotStateCsrLevel";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/aotstatescheduleovrd`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    if (currentIndex !== initialIndex) {
      setParamsData({
        ...initialParamsData,
        conditionDescription1: "",
        aocSeqNbr: selectedCriterias[currentIndex]?.aocSeqNbr,
        hiddenRecordIndicator: "A",
      });
    }
  }, [currentIndex]);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, selectedOption]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = { prcPriceScheduleName: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/priceschedule", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/aotstatescheduleovrd/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
    inActivateSchedule,
    isInactiveConfirmationModalOpen,
    closeInactiveConfirmationModal,
    setInactiveSelectedOption,
  };
};

export default useAccumulatorOverrideStateSchedule;
